import React, { Fragment, useEffect, useState } from "react";
import "./dashboard.scss";
import { useNavigate } from "react-router-dom";
import { Card, Modal } from "react-bootstrap";
import moment from "moment";
import {
    academyusergetdetail,
    listevent,
    listhostelentry,
    workerdashboardcount,
} from "../../services/admin";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
function Wardendashboard() {
    const navigate = useNavigate();
    const [role, setRole] = useState("");
    const [academy, setAcademy] = useState("");
    const [wordet, setWorDet] = useState("");
    const [events, setEvents] = useState([]);
    const [nlist, setNList] = useState([]);
    const [mfilter, setMFilter] = useState([]);
    const [vlist, setVList] = useState([]);

    useEffect(() => {
        if (localStorage.getItem("Role") !== "1") {
            academyusergetdetail(localStorage.getItem("UID")).then((res) => {
                if (res.status === true) {
                    setAcademy(res.data.details.academy_name);
                    setRole(res.data.details.role_name);
                }
            });

            const temp = new FormData();
            temp.append("user_id", localStorage.getItem("UID"));
            temp.append("role_id", localStorage.getItem("Role"));
            temp.append("date", moment(new Date()).format("YYYY-MM-DD"));
            workerdashboardcount(temp).then((res) => {
                if (res.status === true) {
                    setNList(res.data);
                    setVList(res.data.visitor);
                    setWorDet(res.data.workers);
                }
            });

            setEvents([]);
            const temp1 = new FormData();
            temp1.append("academy_id", localStorage.getItem("academy"));
            listevent(temp1).then((res) => {
                if (res.status === true) {
                    setEvents(res.data.details);
                }
            });

            const temp2 = new FormData();
            temp2.append("academy_id", localStorage.getItem("academy"));
            temp2.append("type", "");
            temp2.append("status", 1);

            listhostelentry(temp2).then((res) => {
                if (res.status === true) {
                    setMFilter(res.data);
                }
            });
        }
    }, []);
    const startAutoScroll = () => {
        const scrollContainer = document.getElementById("auto-scroll");
        const announcementList = document.getElementById("announcement-list");

        // Duplicate the list for seamless scrolling
        if (!announcementList.classList.contains("duplicated")) {
            const clone = announcementList.cloneNode(true);
            clone.id = "";
            clone.classList.add("duplicate");
            scrollContainer.appendChild(clone);
            announcementList.classList.add("duplicated");
        }

        const scrollSpeed = 1; // Pixels per step

        if (scrollContainer) {
            window.scrollInterval = setInterval(() => {
                scrollContainer.scrollTop += scrollSpeed;

                // Reset scroll position when reaching the end of the first list
                if (scrollContainer.scrollTop >= announcementList.scrollHeight) {
                    scrollContainer.scrollTop = 0;
                }
            }, 30); // Interval in milliseconds
        }
    };

    // Start auto-scrolling on page load
    document.addEventListener("DOMContentLoaded", startAutoScroll);
    const startBirthdayScroll = () => {
        const scrollContainer = document.getElementById("birthday-scroll");
        const birthdayList = document.getElementById("birthday-list");

        // Duplicate the list for seamless scrolling
        if (!birthdayList.classList.contains("duplicated")) {
            const clone = birthdayList.cloneNode(true);
            clone.id = "";
            clone.classList.add("duplicate");
            scrollContainer.appendChild(clone);
            birthdayList.classList.add("duplicated");
        }

        const scrollSpeed = 1; // Pixels per step

        if (scrollContainer) {
            window.scrollInterval = setInterval(() => {
                scrollContainer.scrollTop += scrollSpeed;

                // Reset scroll position when reaching the end of the first list
                if (scrollContainer.scrollTop >= birthdayList.scrollHeight) {
                    scrollContainer.scrollTop = 0;
                }
            }, 30); // Interval in milliseconds
        }
    };

    // Start auto-scrolling on page load
    document.addEventListener("DOMContentLoaded", startBirthdayScroll);

    const [ashow, setAShow] = useState(false);
    const [anndet, setAnnDet] = useState("");
    function handleView(hdata) {
        setAnnDet(hdata);
        setAShow(true);
    }

    function handleAClose() {
        setAShow(false);
        setAnnDet("");
    }

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState("");
    const openModal = (event) => {
        setSelectedEvent(event);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setSelectedEvent("");
        setModalIsOpen(false);
    };

    const handleEventClick = (info) => {
        const clickedEvent = {
            title: info.event.title,
            start: info.event.start,
            end: info.event.end,
            description: info.event.extendedProps.description,
            location: info.event.extendedProps.location,
            circular:
                info.event.extendedProps.circular === ""
                    ? ""
                    : info.event.extendedProps.path + info.event.extendedProps.circular,
        };
        openModal(clickedEvent);
    };

    return (
        <Fragment>
            <div className="main-container container-fluid">
                <div className="inner-body">
                    {/* Page Header */}
                    <div className="page-header">
                        <h2 className="main-content-title tx-24 mg-b-5">
                            Welcome To Dashboard
                        </h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a>Home</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Dashboard
                            </li>
                        </ol>
                    </div>
                    {/* End Page Header */}
                    {/*Row*/}
                    <div className="row row-sm">
                        <div className="col-sm-12 col-lg-12 col-xl-8">
                            {/*Row*/}
                            <div className="row row-sm  mt-lg-4">
                                <div className="col-sm-12 col-lg-12 col-xl-12">
                                    <div className="bg-black-2 custom-card card-box card">
                                        <div className="card-body p-4">
                                            <div className="row align-items-center">
                                                <div className="offset-xl-3 offset-sm-6 col-xl-8 col-sm-6 col-12 img-bg ">
                                                    <h4 className="d-flex  mb-3">
                                                        <span className="font-weight-bold text-white ">
                                                            {localStorage.getItem("Role") == 1
                                                                ? "AMY Technologies Public School"
                                                                : `${academy}`}
                                                        </span>
                                                    </h4>
                                                    <p className="tx-white-7 mb-1">
                                                        Welcome Back{" "}
                                                        <b className="text-warning">
                                                            {localStorage.getItem("Role") == 1
                                                                ? "Hostel Warden"
                                                                : `${role}`}
                                                        </b>{" "}
                                                        See our Todays Dashboard{" "}
                                                        <b className="text-warning">
                                                            {moment(new Date()).format("DD-MM-YYYY")}
                                                        </b>
                                                        <br></br>
                                                        Have a Nice Day
                                                    </p>
                                                </div>
                                                <img
                                                    src={require("../../assets/images/dashboard/hostel.png")}
                                                    alt="Student"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {localStorage.getItem("Role") == 1 && (
                                <>
                                    <div className="col-sm-12 col-lg-12 col-xl-12">
                                        <div className="row row-sm">
                                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                <div class="card custom-card student-card">
                                                    <div class="card-body">
                                                        <div class="card-order ">
                                                            <label class="main-content-label student-name-card mb-3 pt-1">
                                                                My Unique Number
                                                            </label>
                                                            <h2 class="text-end card-item-icon card-icon">
                                                                <i class="fa fa-user-circle-o icon-size float-start text-primary"></i>
                                                                <span class="student-no font-weight-bold">
                                                                    AMYS25W134
                                                                </span>
                                                            </h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                <div class="card custom-card student-card">
                                                    <div class="card-body">
                                                        <div class="card-order ">
                                                            <label class="main-content-label student-name-card mb-3 pt-1">
                                                                Employee ID
                                                            </label>
                                                            <h2 class="text-end card-item-icon card-icon">
                                                                <i class="fa fa-user icon-size float-start text-primary"></i>
                                                                <span class="student-no font-weight-bold">
                                                                    A-1234
                                                                </span>
                                                            </h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                <div class="card custom-card student-card">
                                                    <div class="card-body">
                                                        <div class="card-order ">
                                                            <label class="main-content-label student-name-card mb-3 pt-1">
                                                                Today Visitors
                                                            </label>
                                                            <h2 class="text-end card-item-icon card-icon">
                                                                <i class="fa fa-user-plus icon-size float-start text-primary"></i>
                                                                <span class="student-no font-weight-bold">
                                                                    8
                                                                </span>
                                                            </h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-12 col-xl-12">
                                        <div className="row row-sm">
                                            <div class="col-md-6 col-xl-4">
                                                <div class="card custom-card">
                                                    <div class="card-bodyy">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div className="product-content">
                                                                    <h3 className="title">
                                                                        <a>TEACHERS</a>
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                        <div className="col-md-6 col justify-content-center text-center">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>8</a> <p className="text-muted ">Boys</p>
                                                            </h3>
                                                        </div>
                                                        <div className="col-md-6 col text-center float-end">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>5</a> <p className="text-muted ">Girls</p>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-xl-4">
                                                <div class="card custom-card">
                                                    <div class="card-bodyy">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div className="product-content">
                                                                    <h3 className="title">
                                                                        <a>STUDENTS</a>
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                        <div className="col-md-6 col justify-content-center text-center">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>68</a> <p className="text-muted ">Boys</p>
                                                            </h3>
                                                        </div>
                                                        <div className="col-md-6 col text-center float-end">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>47</a> <p className="text-muted ">Girls</p>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-xl-4">
                                                <div class="card custom-card">
                                                    <div class="card-bodyy">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div className="product-content">
                                                                    <h3 className="title">
                                                                        <a>TOTAL ROOMS</a>
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                        <div className="col-md-6 col justify-content-center text-center">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>13</a> <p className="text-muted ">Boys</p>
                                                            </h3>
                                                        </div>
                                                        <div className="col-md-6 col text-center float-end">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>19</a> <p className="text-muted ">Girls</p>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row row-sm">
                                        <div
                                            className="col-sm-12 col-md-12 col-lg-6 col-xl-12"
                                            data-wow-delay="1.5s"
                                        >
                                            <Card className="custom-card">
                                                <Card.Header className="">
                                                    <div className="d-md-flex ms-auto">
                                                        <label className="main-content-label my-auto pt-2">
                                                            <i className="fa fa-calendar headericons"></i>{" "}
                                                            Events calendar
                                                        </label>
                                                    </div>
                                                </Card.Header>
                                                <Card.Body>
                                                    <FullCalendar
                                                        plugins={[dayGridPlugin]}
                                                        initialView="dayGridMonth"
                                                        events={events.map((event) => ({
                                                            title: event.event_name,
                                                            start: event.event_start,
                                                            end: event.event_end || event.event_start,
                                                            description: event.description,
                                                            location: event.location,
                                                            path: event.path,
                                                            circular: event.circular,
                                                            backgroundColor: "#b04751",
                                                            textColor: "#fff",
                                                        }))}
                                                        eventClick={handleEventClick}
                                                    />
                                                </Card.Body>
                                            </Card>
                                        </div>

                                        {/* col end */}
                                    </div>
                                </>
                            )}

                            {localStorage.getItem("Role") != 1 && (
                                <>
                                    <div className="col-sm-12 col-lg-12 col-xl-12">
                                        <div className="row row-sm">
                                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                <div class="card custom-card student-card">
                                                    <div class="card-body">
                                                        <div class="card-order ">
                                                            <label class="main-content-label student-name-card mb-3 pt-1">
                                                                My Unique Number
                                                            </label>
                                                            <h2 class="text-end card-item-icon card-icon">
                                                                <i class="fa fa-user-circle-o icon-size float-start text-primary"></i>
                                                                <span class="student-no font-weight-bold">
                                                                    {wordet ? wordet.username : ""}
                                                                </span>
                                                            </h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                <div class="card custom-card student-card">
                                                    <div class="card-body">
                                                        <div class="card-order ">
                                                            <label class="main-content-label student-name-card mb-3 pt-1">
                                                                Employee ID
                                                            </label>
                                                            <h2 class="text-end card-item-icon card-icon">
                                                                <i class="fa fa-user icon-size float-start text-primary"></i>
                                                                <span class="student-no font-weight-bold">
                                                                    {wordet ? wordet.employee_id : ""}
                                                                </span>
                                                            </h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                <div class="card custom-card student-card">
                                                    <div class="card-body">
                                                        <div class="card-order ">
                                                            <label class="main-content-label student-name-card mb-3 pt-1">
                                                                Today Visitors
                                                            </label>
                                                            <h2 class="text-end card-item-icon card-icon">
                                                                <i class="fa fa-user-plus icon-size float-start text-primary"></i>
                                                                <span class="student-no font-weight-bold">
                                                                    {vlist ? vlist.length : ""}
                                                                </span>
                                                            </h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-12 col-xl-12">
                                        <div className="row row-sm">
                                            <div class="col-md-6 col-xl-4">
                                                <div class="card custom-card">
                                                    <div class="card-bodyy">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div className="product-content">
                                                                    <h3 className="title">
                                                                        <a>TEACHERS</a>
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                        <div className="col-md-6 col justify-content-center text-center">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>
                                                                    {nlist && nlist.hostel
                                                                        ? nlist.hostel.male_teacher.length
                                                                        : "0"}
                                                                </a>{" "}
                                                                <p className="text-muted ">Boys</p>
                                                            </h3>
                                                        </div>
                                                        <div className="col-md-6 col text-center float-end">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>
                                                                    {nlist && nlist.hostel
                                                                        ? nlist.hostel.female_teacher.length
                                                                        : "0"}
                                                                </a>{" "}
                                                                <p className="text-muted ">Girls</p>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-xl-4">
                                                <div class="card custom-card">
                                                    <div class="card-bodyy">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div className="product-content">
                                                                    <h3 className="title">
                                                                        <a>STUDENTS</a>
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                        <div className="col-md-6 col justify-content-center text-center">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>
                                                                    {nlist && nlist.hostel
                                                                        ? nlist.hostel.male_student.length
                                                                        : "0"}
                                                                </a>{" "}
                                                                <p className="text-muted ">Boys</p>
                                                            </h3>
                                                        </div>
                                                        <div className="col-md-6 col text-center float-end">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>
                                                                    {nlist && nlist.hostel
                                                                        ? nlist.hostel.female_student.length
                                                                        : "0"}
                                                                </a>{" "}
                                                                <p className="text-muted ">Girls</p>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-xl-4">
                                                <div class="card custom-card">
                                                    <div class="card-bodyy">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div className="product-content">
                                                                    <h3 className="title">
                                                                        <a>TOTAL ROOMS</a>
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                        <div className="col-md-6 col justify-content-center text-center">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>
                                                                    {nlist && nlist.hostel_rooms
                                                                        ? nlist.hostel_rooms.boys_room
                                                                        : "0"}
                                                                </a>{" "}
                                                                <p className="text-muted ">Boys</p>
                                                            </h3>
                                                        </div>
                                                        <div className="col-md-6 col text-center float-end">
                                                            <h3 className="mb-1 font-weight-bold">
                                                                {" "}
                                                                <a>
                                                                    {nlist && nlist.hostel_rooms
                                                                        ? nlist.hostel_rooms.girls_room
                                                                        : "0"}
                                                                </a>{" "}
                                                                <p className="text-muted ">Girls</p>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row row-sm">
                                        <div
                                            className="col-sm-12 col-md-12 col-lg-6 col-xl-12"
                                            data-wow-delay="1.5s"
                                        >
                                            <Card className="custom-card">
                                                <Card.Header className="">
                                                    <div className="d-md-flex ms-auto">
                                                        <label className="main-content-label my-auto pt-2">
                                                            <i className="fa fa-calendar headericons"></i>{" "}
                                                            Events calendar
                                                        </label>
                                                    </div>
                                                </Card.Header>
                                                <Card.Body>
                                                    <FullCalendar
                                                        plugins={[dayGridPlugin]}
                                                        initialView="dayGridMonth"
                                                        events={events.map((event) => ({
                                                            title: event.event_name,
                                                            start: event.event_start,
                                                            end: event.event_end || event.event_start,
                                                            description: event.description,
                                                            location: event.location,
                                                            path: event.path,
                                                            circular: event.circular,
                                                            backgroundColor: "#b04751",
                                                            textColor: "#fff",
                                                        }))}
                                                        eventClick={handleEventClick}
                                                    />
                                                </Card.Body>
                                            </Card>
                                        </div>

                                        {/* col end */}
                                    </div>
                                </>
                            )}
                        </div>
                        {localStorage.getItem("Role") == 1 &&
                            <div className="col-sm-12 col-lg-12 col-xl-4">
                                <div className="card custom-card mg-t-30">
                                    <Card className="custom-card">
                                        <Card.Header>
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2">
                                                    <i className="fa fa-bullhorn headericons"></i>{" "}
                                                    Announcement
                                                </label>
                                            </div>
                                        </Card.Header>
                                        <Card.Body
                                            id="auto-scroll"
                                            onMouseEnter={() => clearInterval(window.scrollInterval)}
                                            // onMouseLeave={startAutoScroll}
                                            style={{
                                                maxHeight: "350px",
                                                overflow: "hidden",
                                                position: "relative",
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <ul
                                                className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                                                id="announcement-list"
                                            >
                                                <li className="d-flex align-items-center mb-3">
                                                    <div className="flex-shrink-0">
                                                        <div className="main-avatar avatar-md online"></div>
                                                    </div>
                                                    <div className="ms-3 flex-grow-1">
                                                        <p className="tx-16 text-dark mb-0 tx-semibold">Happy Tamil New Year</p>
                                                        <p className="mb-0 text-muted tx-16">{moment('2025-04-10').format('DD-MM-YYYY')}</p>
                                                    </div>
                                                    <a class="me-2 mt-1"><span class="badge bg-success-light">View</span></a>
                                                </li>
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className="card custom-card mg-t-30">
                                    <Card className="custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2">
                                                    <i className="fa fa-male headericons"></i> Boys Report
                                                </label>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <li
                                                className="d-flex align-items-center mb-3"
                                            >
                                                <div className="ms-3 flex-grow-1">
                                                    <p className="tx-16 text-dark mb-0 tx-semibold">
                                                        Balaganesh
                                                    </p>
                                                    <p className="mb-0 text-muted tx-16">
                                                        IX - A
                                                    </p>
                                                </div>
                                                <a className="me-2 mt-1">
                                                    <span className="badge bg-success-light">
                                                        Room - 289
                                                    </span>
                                                </a>
                                            </li>
                                            <li
                                                className="d-flex align-items-center mb-3"
                                            >
                                                <div className="ms-3 flex-grow-1">
                                                    <p className="tx-16 text-dark mb-0 tx-semibold">
                                                        Jason
                                                    </p>
                                                    <p className="mb-0 text-muted tx-16">
                                                        X - C
                                                    </p>
                                                </div>
                                                <a className="me-2 mt-1">
                                                    <span className="badge bg-success-light">
                                                        Room - 190
                                                    </span>
                                                </a>
                                            </li>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className="card custom-card mg-t-30">
                                    <Card className="custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2">
                                                    <i className="fa fa-female headericons"></i> Girls
                                                    Report
                                                </label>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <li
                                                className="d-flex align-items-center mb-3"
                                            >
                                                <div className="ms-3 flex-grow-1">
                                                    <p className="tx-16 text-dark mb-0 tx-semibold">
                                                        Adhithi
                                                    </p>
                                                    <p className="mb-0 text-muted tx-16">
                                                        IV - D
                                                    </p>
                                                </div>
                                                <a className="me-2 mt-1">
                                                    <span className="badge bg-success-light">
                                                        Room - 68
                                                    </span>
                                                </a>
                                            </li>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        }

                        {localStorage.getItem("Role") != 1 &&
                            <div className="col-sm-12 col-lg-12 col-xl-4">
                                <div className="card custom-card mg-t-30">
                                    <Card className="custom-card">
                                        <Card.Header>
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2">
                                                    <i className="fa fa-bullhorn headericons"></i>{" "}
                                                    Announcement
                                                </label>
                                            </div>
                                        </Card.Header>
                                        <Card.Body
                                            id="auto-scroll"
                                            onMouseEnter={() => clearInterval(window.scrollInterval)}
                                            // onMouseLeave={startAutoScroll}
                                            style={{
                                                maxHeight: "350px",
                                                overflow: "hidden",
                                                position: "relative",
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <ul
                                                className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                                                id="announcement-list"
                                            >
                                                {nlist &&
                                                    nlist.notification &&
                                                    nlist.notification.length > 0 ? (
                                                    nlist.notification.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className="d-flex align-items-center mb-3"
                                                        >
                                                            <div className="flex-shrink-0">
                                                                <div className="main-avatar avatar-md online"></div>
                                                            </div>
                                                            <div className="ms-3 flex-grow-1">
                                                                <p className="tx-16 text-dark mb-0 tx-semibold">
                                                                    {item.title}
                                                                </p>
                                                                <p className="mb-0 text-muted tx-16">
                                                                    {moment(item.created_at).format("DD-MM-YYYY")}
                                                                </p>
                                                            </div>
                                                            <a
                                                                className="me-2 mt-1"
                                                                onClick={() => handleView(item)}
                                                            >
                                                                <span className="badge bg-success-light">
                                                                    View
                                                                </span>
                                                            </a>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <h6>No Announcement found.</h6>
                                                )}
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className="card custom-card mg-t-30">
                                    <Card className="custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2">
                                                    <i className="fa fa-male headericons"></i> Boys Report
                                                </label>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            {mfilter.length > 0 ? (
                                                (() => {
                                                    const filteredItems = mfilter.filter(
                                                        (item) => item.hostel_type == "Boys"
                                                    );
                                                    return filteredItems.length > 0 ? (
                                                        filteredItems.map((item, index) => (
                                                            <li
                                                                key={index}
                                                                className="d-flex align-items-center mb-3"
                                                            >
                                                                <div className="ms-3 flex-grow-1">
                                                                    <p className="tx-16 text-dark mb-0 tx-semibold">
                                                                        {item.student_name} (
                                                                        {item.role_id == 4
                                                                            ? "Student"
                                                                            : item.role_id == 5
                                                                                ? "Teacher"
                                                                                : ""}
                                                                        )
                                                                    </p>
                                                                    <p className="mb-0 text-muted tx-16">
                                                                        {item.class_name}
                                                                    </p>
                                                                </div>
                                                                <a className="me-2 mt-1">
                                                                    <span className="badge bg-success-light">
                                                                        Room - {item.room_no}
                                                                    </span>
                                                                </a>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <h6>No Records found.</h6>
                                                    );
                                                })()
                                            ) : (
                                                <h6>No Records found.</h6>
                                            )}
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className="card custom-card mg-t-30">
                                    <Card className="custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2">
                                                    <i className="fa fa-female headericons"></i> Girls
                                                    Report
                                                </label>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            {mfilter.length > 0 ? (
                                                (() => {
                                                    const filteredItems = mfilter.filter(
                                                        (item) => item.hostel_type == "Girls"
                                                    );
                                                    return filteredItems.length > 0 ? (
                                                        filteredItems.map((item, index) => (
                                                            <li
                                                                key={index}
                                                                className="d-flex align-items-center mb-3"
                                                            >
                                                                <div className="ms-3 flex-grow-1">
                                                                    <p className="tx-16 text-dark mb-0 tx-semibold">
                                                                        {item.student_name} (
                                                                        {item.role_id == 4
                                                                            ? "Student"
                                                                            : item.role_id == 5
                                                                                ? "Teacher"
                                                                                : ""}
                                                                        )
                                                                    </p>
                                                                    <p className="mb-0 text-muted tx-16">
                                                                        {item.class_name}
                                                                    </p>
                                                                </div>
                                                                <a className="me-2 mt-1">
                                                                    <span className="badge bg-success-light">
                                                                        Room - {item.room_no}
                                                                    </span>
                                                                </a>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <h6>No Records found.</h6>
                                                    );
                                                })()
                                            ) : (
                                                <h6>No Records found.</h6>
                                            )}
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        }

                        <Modal show={ashow} onHide={handleAClose}>
                            <Modal.Header>
                                <Modal.Title>Announcement Details</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>Title</label>
                                                </div>
                                                <div className="col-md-8">
                                                    <a>{anndet.title}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>Message</label>
                                                </div>
                                                <div className="col-md-8">
                                                    <a>{anndet.message}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <a className="btn btn-secondary" onClick={handleAClose}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={modalIsOpen} size="md">
                            <Modal.Header>
                                <Modal.Title>Events</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="table-responsive">
                                    <h4>{selectedEvent.title}</h4>
                                    <p>
                                        <strong>Start Date :</strong>{" "}
                                        {moment(selectedEvent.start).format("DD-MM-YYYY")}
                                    </p>
                                    <p>
                                        <strong>End Date :</strong>{" "}
                                        {moment(selectedEvent.end).format("DD-MM-YYYY")}
                                    </p>
                                    <p>
                                        <strong>Location :</strong> {selectedEvent.location}
                                    </p>
                                    <p>
                                        <strong>Description :</strong> {selectedEvent.description}
                                    </p>
                                    {selectedEvent.circular !== "" && (
                                        <p>
                                            <strong>Circular:</strong>{" "}
                                            <a
                                                href={selectedEvent.circular}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                View Circular
                                            </a>
                                        </p>
                                    )}
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <a className="btn btn-info" onClick={closeModal}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>
                    </div>
                    {/* Row end */}
                </div>
            </div>
        </Fragment>
    );
}

Wardendashboard.propTypes = {};

Wardendashboard.defaultProps = {};

export default Wardendashboard;
